import type { AudioExportSettings } from "../exportAudioOptions";
import { normalizeAudioExportFormat, normalizeAudioExportSampleRate } from "../exportAudioOptions";

/**
 * Separate Speakers defaults are fixed so the workflow stays predictable and robust.
 * We intentionally avoid the main export-quality selector here.
 */
export const DECOMPOSE_AUDIO_EXPORT_SETTINGS: AudioExportSettings = {
    format: "m4a",
    bitrate: 160000,
    channels: 2,
    sampleRate: 48000,
};

export const resolveDecomposeAudioExportSettings = (args: {
    defaultFormat?: unknown;
    defaultSampleRate?: unknown;
}): AudioExportSettings => ({
    ...DECOMPOSE_AUDIO_EXPORT_SETTINGS,
    format: normalizeAudioExportFormat(args.defaultFormat),
    sampleRate: normalizeAudioExportSampleRate(args.defaultSampleRate),
});
